export default __webpack_public_path__ + "static/media/match-bet-card.191b47c6.png";